import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { catchError, map, of } from "rxjs";
import { AuthService } from "./auth.service";
import {
  GuardDecision,
  decideAuthGuard,
  decideLoginGuard,
  decidePortalGuard,
} from "./auth.guard.logic";

const resolve = (router: Router, d: GuardDecision): true | UrlTree =>
  d === true ? true : router.createUrlTree([d.redirectTo]);

export const authGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const need = route.data?.["perm"] as string | undefined;

  const decide = () => resolve(router, decideAuthGuard(auth, need));

  if (auth.loaded()) return decide();

  return auth.refresh().pipe(
    map(() => decide()),
    catchError(() => {
      auth.clear();
      return of(router.createUrlTree(["/login"]));
    }),
  );
};

export const portalGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const decide = () => resolve(router, decidePortalGuard(auth));

  if (auth.loaded()) return decide();

  return auth.refresh().pipe(
    map(() => decide()),
    catchError(() => {
      auth.clear();
      return of(router.createUrlTree(["/login"]));
    }),
  );
};

export const loginGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const decide = () => resolve(router, decideLoginGuard(auth));

  if (auth.loaded()) return decide();

  return auth.refresh().pipe(
    map(() => decide()),
    catchError(() => {
      auth.clear();
      return of(true);
    }),
  );
};
